(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kc-anchor-page"] && !Shopify.designMode) return;
  try {
    
  class KcAnchorPage extends HTMLElement {
    connectedCallback() {
      this.sections = Array.from(this.querySelectorAll('.kc-anchor-section')).filter((s) => s.id);
      if (this.sections.length === 0) return;

      this.buildRail();
      this.links = Array.from(this.querySelectorAll('.kc-anchor-page__rail-link'));

      this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
        rootMargin: '-15% 0px -70% 0px',
        threshold: 0,
      });
      this.sections.forEach((section) => this.observer.observe(section));
      this.setActive(this.sections[0].id);
    }

    buildRail() {
      const list = this.querySelector('.kc-anchor-page__rail-list');
      if (!list) return;
      const items = this.sections.map((section) => {
        const title = section.querySelector('.kc-anchor-section__title')?.textContent.trim() ?? section.id;
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.className = 'kc-anchor-page__rail-link';
        a.href = `#${section.id}`;
        a.textContent = title;
        li.appendChild(a);
        return li;
      });
      list.replaceChildren(...items);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    onIntersect(entries) {
      const visible = entries.filter((entry) => entry.isIntersecting);
      if (visible.length === 0) return;
      this.setActive(visible[0].target.id);
    }

    setActive(id) {
      this.links.forEach((link) => {
        const isCurrent = link.getAttribute('href') === `#${id}`;
        if (isCurrent) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }
  }

  if (!customElements.get('kc-anchor-page')) {
    customElements.define('kc-anchor-page', KcAnchorPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
